/**
 * Created by Ninghai on 2017/12/19.
 */
export default {
  getChartById: state => id => {
    return state.charts[id]
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js